import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Play } from 'lucide-react';

const ActionNode = ({ data, selected }) => {
  return (
    <div className={`px-4 py-3 rounded-lg border-2 bg-white shadow-md min-w-[200px] transition-shadow ${
      selected ? 'border-green-600 shadow-lg ring-4 ring-green-200' : 'border-green-500'
    }`}>
      <Handle
        type="target"
        position={Position.Top}
        className="!bg-green-500 !w-3 !h-3 !border-2 !border-white"
      />
      <div className="flex items-center gap-2">
        <div className="p-1.5 rounded bg-green-50">
          <Play className="text-green-500" size={16} />
        </div>
        <span className="font-medium text-sm text-green-700">Then...</span>
      </div>
      <div className="text-xs text-gray-600 mt-1.5 truncate">
        {data.label || 'Select an action'}
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        className="!bg-green-500 !w-3 !h-3 !border-2 !border-white"
      />
    </div>
  );
};

export default ActionNode;